import { lazy, Suspense } from 'react';

import SuspenseLoader from 'src/components/SuspenseLoader';
import RouteGuard from 'src/components/RouteGuard';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const WOAnalytics = Loader(
  lazy(() => import('../content/own/Analytics/WorkOrder'))
);
const AssetAnalytics = Loader(
  lazy(() => import('../content/own/Analytics/Asset'))
);
const PartAnalytics = Loader(
  lazy(() => import('../content/own/Analytics/Part'))
);
const RequestAnalytics = Loader(
  lazy(() => import('../content/own/Analytics/Request'))
);
const analyticsRoutes = [
  {
    path: 'work-orders',
    children: [
      { path: 'status', element: <WOAnalytics /> },
      { path: 'analysis', element: <WOAnalytics /> },
      { path: 'aging', element: <WOAnalytics /> },
      { path: 'time-cost', element: <WOAnalytics /> }
    ]
  },
  {
    path: 'assets',
    children: [
      { path: 'reliability', element: <AssetAnalytics /> },
      { path: 'cost', element: <AssetAnalytics /> },
      { path: 'useful-life', element: <AssetAnalytics /> }
    ]
  },
  {
    path: 'parts',
    children: [{ path: 'consumption', element: <PartAnalytics /> }]
  },
  // Ruta de requests oculta - redirige a work-orders
  {
    path: 'requests',
    children: [
      {
        path: '*',
        element: <RouteGuard />
      }
    ]
  }
];

export default analyticsRoutes;
